import { Badge } from "components/ui/Badge/Badge";
import type { BadgeTone } from "components/ui/StatusBadge/StatusBadge";
import type { ReplyParentType } from "hooks/use-email-replies-api";
import { Megaphone, Send } from "lucide-react";
import type { FC } from "react";

export type ReplyParentPillProps = {
  type: ReplyParentType;
  /** Compact 用にサイズを縮める. リスト行など狭い場所で true. */
  compact?: boolean;
};

const TONE_BY_TYPE: Record<ReplyParentType, BadgeTone> = {
  delivery: "stage-1",
  sent_email: "soft-info",
};

const LABEL_BY_TYPE: Record<ReplyParentType, string> = {
  delivery: "一斉",
  sent_email: "個別",
};

const ICON_BY_TYPE: Record<ReplyParentType, typeof Megaphone> = {
  delivery: Megaphone,
  sent_email: Send,
};

const TITLE_BY_TYPE: Record<ReplyParentType, string> = {
  delivery: "一斉配信のリプライ",
  sent_email: "個別送信のリプライ",
};

/**
 * リプライの parentType (一斉 / 個別) を視覚的に区別する Badge ラッパ.
 * Badge LEAF (icon + size) を使うため画面横断で一貫した見た目になる.
 * @param {ReplyParentPillProps} props parentType と compact フラグ
 * @return {JSX.Element} Badge
 */
export const ReplyParentPill: FC<ReplyParentPillProps> = ({
  type,
  compact = false,
}) => {
  return (
    <Badge
      tone={TONE_BY_TYPE[type]}
      size={compact ? "xs" : "sm"}
      icon={ICON_BY_TYPE[type]}
      title={TITLE_BY_TYPE[type]}
    >
      {LABEL_BY_TYPE[type]}
    </Badge>
  );
};
